import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/notificationActions";
import * as api from "../../api/notificationApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getNotifications(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getNotifications(action.payload);
        yield put(actions.setNotificationList(data || undefined));
    } catch (error) {
        yield put(actions.setNotificationList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* readUserNotification(action) {
    yield put(resetBackdrop());
    try {
        yield api.readUserNotification(action.payload);
        yield put(actions.getNotificationList(action.payload));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* setSubscribeNotification(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.setSubscribeNotification(action.payload);
        yield put(actions.setNotificationSubscriptionOfUser(data || undefined));
        if (!action.fromOverview) {
            yield put(showSuccessSnackbar(data.message));
        }
    } catch (error) {
        console.log("Subscription failed");
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getNotificationSubscriptionOfUser(action) {
    try {
        const { data } = yield api.getNotificationSubscriptionOfUser(action.payload);
        yield put(actions.setNotificationSubscriptionOfUser(data || undefined));
    } catch (error) {
        yield put(actions.setNotificationSubscriptionOfUser(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteSubscription(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteSubscription(action.payload);
        yield put(actions.setNotificationSubscriptionOfUser(undefined));
        if (!action.fromOverview) {
        yield put(showSuccessSnackbar(data.message));
        }
    } catch (error) {
        console.log("Subscription delete failed");
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getNotificationLanguages(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getNotificationLanguages(action.payload);
        yield put(actions.setNotificationLanguages(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setNotificationLanguages(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* setNotificationLanguage(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.setNotificationLanguage(action.payload);
        yield put(actions.setUserNotificationLanguage(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.SET_SUBSCRIBE_NOTIFICATION, setSubscribeNotification);
    yield takeEvery(actions.Types.NOTIFICATION_DELETE, deleteSubscription);
    yield takeEvery(actions.Types.GET_NOTIFICATION_SUBSCRIPTION_OF_USER, getNotificationSubscriptionOfUser);
    yield takeEvery(actions.Types.GET_NOTIFICATION_LIST, getNotifications);
    yield takeEvery(actions.Types.READ_USER_NOTIFICATION, readUserNotification);
    yield takeEvery(actions.Types.GET_NOTIFICATION_LANGUAGES, getNotificationLanguages);
    yield takeEvery(actions.Types.SET_NOTIFICATION_LANGUAGE, setNotificationLanguage);
}

const notificationSaga = [fork(watchAll)];

export default notificationSaga;
